var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"data-aos":"fade-up","data-aos-duration":"1500"}},[_vm._v("This is Games Page")]),_c('GameCards',{attrs:{"data-aos":"fade-up","data-aos-duration":"1500"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }